import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { INFOBLOCK_FEATURE, InfoblockState, StateWithInfoblock } from '../infoblock-state';

export const getInfoblockFeatureState: MemoizedSelector<StateWithInfoblock, InfoblockState> =
  createFeatureSelector<InfoblockState>(INFOBLOCK_FEATURE);
